<div class="relative w-full flex flex-col flex-1 h-full">
  @if (spinner) {
  <div class="flex items-center justify-center flex-1 h-full py-10">
    <mg-spinner [show]="true"></mg-spinner>
  </div>
  } @else {
    @for (item of dynamicMergedList; track $index) {
      @if (isDynamicInterval(item)) {
      <div @cardEnter class="pb-5">
        <div class="flex items-center gap-2 mb-2">
          <mg-icon iconName="search_activity" iconClass="text-xl text-mg-main-blue-dark"></mg-icon>
          <span class="text-md font-semibold text-mg-main-blue-dark tracking-wider">
            Intervalo {{ item.index + 1 }}
          </span>
        </div>
        @if (item.data.inicio) {
        <div @markEnter class="flex flex-col overflow-hidden border border-mg-main-blue rounded-xl min-h-[83px] bg-white transition-all duration-300"
          [class.!bg-mg-main-blue-light]="item.data.inicio.isEnProceso"
          [class.!border-mg-main-blue]="item.data.inicio.isEnProceso">
        <div class="flex items-center justify-between px-2 py-3.5">
          <div class="flex items-center gap-3 min-w-0">
            <div class="w-9 h-9 rounded-full border bg-mg-main-blue-light border-mg-main-blue flex items-center justify-center flex-shrink-0"
              [class.!bg-mg-main-blue]="item.data.inicio.isEnProceso"
              [class.!bg-mg-sunshine-light]="!item.data.inicio.isEnProceso && item.data.inicio.bEsPendiente"
              [class.!border-mg-sunshine-dark]="!item.data.inicio.isEnProceso && item.data.inicio.bEsPendiente"
              [class.!bg-mg-green-light]="!item.data.inicio.isEnProceso && item.data.inicio.bEsAprobada"
              [class.!border-mg-green-dark]="!item.data.inicio.isEnProceso && item.data.inicio.bEsAprobada"
              [matTooltip]="getDeviceTooltip(item.data.inicio)"
              [matTooltipPosition]="(isScreenSM$ | async) ? 'left' : 'above'">
              <mg-icon [iconName]="item.data.inicio.sIcono_Marcaje ?? 'computer'" iconClass="leading-none text-base"
                [class.text-white]="item.data.inicio.isEnProceso"
                [class.text-mg-main-blue-dark]="!item.data.inicio.isEnProceso && !item.data.inicio.bEsPendiente && !item.data.inicio.bEsAprobada"
                [class.text-mg-sunshine-dark]="!item.data.inicio.isEnProceso && item.data.inicio.bEsPendiente"
                [class.text-mg-green-dark]="!item.data.inicio.isEnProceso && item.data.inicio.bEsAprobada"
              ></mg-icon>
            </div>
            <div class="flex flex-col min-w-0">
              <div class="flex items-baseline gap-2 leading-none">
                <span class="text-xl font-bold text-mg-main-blue-dark leading-none">
                  {{ item.data.inicio.dTiempo_Marca | date: 'HH:mm' }}
                </span>
                <span class="text-mg-main-blue-dark text-lg"> | </span>
                <span class="text-md text-mg-main-blue-dark">Inicio</span>
              </div>
              <div class="flex items-center gap-1.5">
                <mg-icon iconName="today" iconClass="leading-none text-sm text-mg-main-blue-dark"></mg-icon>
                <span class="text-sm text-mg-main-blue-dark">
                  {{ item.data.inicio.dTiempo_Marca | date: 'dd/MM/yyyy' }}
                </span>
              </div>
            </div>
          </div>
          <div class="flex items-center justify-end gap-1.5 flex-shrink-0 ml-2 sm:min-w-[120px]">
            @if (item.data.inicio.isEnProceso) {
              <div class="flex flex-col items-end justify-between gap-1.5 self-stretch py-0.5">
                <span class="text-[10px] font-bold px-2 py-0.5 rounded-full leading-tight whitespace-nowrap"
                  [ngClass]="getActionCss(item.data.inicio.displayActionType)">
                  {{ getActionLabel(item.data.inicio.displayActionType) }}
                </span>
                <div class="flex items-center gap-1">
                  <span class="text-xs text-mg-main-blue-dark font-medium whitespace-nowrap">En Proceso</span>
                </div>
              </div>
            } @else {
              @if (item.data.inicio.bEsPendiente) {
                <div class="hidden sm:flex items-center gap-1.5 text-sm text-mg-sunshine-dark border border-mg-sunshine-dark bg-mg-sunshine-light rounded-lg px-2.5 py-1">
                  <mg-icon iconName="schedule" iconClass="text-mg-sunshine-dark leading-none text-sm"></mg-icon>
                  <span>Pendiente</span>
                </div>
              } @else if (item.data.inicio.bEsAprobada) {
                <div class="hidden sm:flex items-center gap-1.5 text-sm text-mg-green-dark border border-mg-green-dark bg-mg-green-light rounded-lg px-2.5 py-1">
                  <mg-icon iconName="check_circle" iconClass="text-mg-green-dark leading-none text-sm"></mg-icon>
                  <span>Aprobada</span>
                </div>
              }
              @if (editMode && !lockButtons && !item.data.inicio.bIs_Extemporanea && (!item.data.inicio.bEsPendiente || item.index > 0)) {
                @if ((showEditButtons && !item.data.inicio.bEsPendiente) || showDelete(item.data.inicio)) {
                  @if(!(isScreenSM$ | async)){
                    <button class="sm:hidden" mat-icon-button [matMenuTriggerFor]="menuInicio">
                      <mg-icon iconName="more_vert" iconClass="text-mg-main-blue-dark leading-none text-base"></mg-icon>
                    </button>
                    <mat-menu #menuInicio="matMenu">
                      @if(showEditButtons && !item.data.inicio.bEsPendiente){
                        <button mat-menu-item
                          (click)="editarMarca.emit({ nInterval: item.data.inicio.originalNInterval, nIndex: item.index + 1, nType_Mark: item.data.inicio.originalNType_Mark, sHour: getHora(item.data.inicio.dTiempo_Marca), sOriginalHour: getHora(item.data.inicio.dTiempo_Marca) })">
                          <mg-icon matMenuItemIcon iconName="edit" iconClass="text-mg-main-blue-dark leading-none text-base"></mg-icon>
                          <div class="text-sm pl-1">Editar</div>
                        </button>
                      }
                      @if(showDelete(item.data.inicio)){
                        <button mat-menu-item
                          (click)="editarMarca.emit({ nInterval: item.data.inicio.originalNInterval, nIndex: item.index + 1, nType_Mark: item.data.inicio.originalNType_Mark, sHour: '', sOriginalHour: getHora(item.data.inicio.dTiempo_Marca) })">
                          <mg-icon matMenuItemIcon iconName="delete" iconClass="text-mg-red-dark leading-none text-base"></mg-icon>
                          <div class="text-sm pl-1">Eliminar</div>
                        </button>
                      }
                    </mat-menu>
                  } @else {
                    @if(showEditButtons && !item.data.inicio.bEsPendiente){
                      <button
                        class="hidden sm:flex w-6 h-6 rounded-full bg-mg-main-blue-light items-center justify-center"
                        (click)="editarMarca.emit({ nInterval: item.data.inicio.originalNInterval, nIndex: item.index + 1, nType_Mark: item.data.inicio.originalNType_Mark, sHour: getHora(item.data.inicio.dTiempo_Marca), sOriginalHour: getHora(item.data.inicio.dTiempo_Marca) })">
                        <mg-icon iconName="edit" iconClass="text-mg-main-blue-dark leading-none text-base"></mg-icon>
                      </button>
                    }
                    @if(showDelete(item.data.inicio)){
                      <button
                        class="hidden sm:flex w-6 h-6 rounded-full bg-mg-red-light items-center justify-center"
                        (click)="editarMarca.emit({ nInterval: item.data.inicio.originalNInterval, nIndex: item.index + 1, nType_Mark: item.data.inicio.originalNType_Mark, sHour: '', sOriginalHour: getHora(item.data.inicio.dTiempo_Marca) })">
                        <mg-icon iconName="delete" iconClass="text-mg-red-dark leading-none text-base"></mg-icon>
                      </button>
                    }
                  }
                }
              }
            }
          </div>
        </div>
        @if (item.data.inicio.isEnProceso && item.data.inicio.displayActionType !== 'add') {
        <div @markEnter class="mx-2 mb-1.5 flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-mg-main-blue-dark text-white text-[11px] font-semibold tracking-wide">
          <span>{{ getActionLabel(item.data.inicio.displayActionType) }}</span>
          <span class="font-normal opacity-80">DE MARCA</span>
          <span>{{ item.data.inicio.originalTime | date: 'HH:mm' }}</span>
          <span class="font-normal opacity-80">DEL DÍA</span>
          <span>{{ item.data.inicio.originalTime | date: 'dd/MM/yyyy' }}</span>
        </div>
        }
        @if (item.index === 0 && tardinessBadge) {
        <div class="flex items-center gap-1.5 px-2 pb-2 text-xs font-semibold text-mg-red-intense">
          <mg-icon iconName="error" iconClass="text-sm leading-none text-mg-red-intense"></mg-icon>
          <span>{{ tardinessBadge.sTipo_Badge }} de {{ tardinessBadge.nMinutos }} min.</span>
        </div>
        }
        </div>
        } @else if (item.data.fin) {
        <div class="flex items-center gap-3 border border-mg-main-blue rounded-xl px-2 py-3.5 bg-white min-h-[83px]">
          <div class="w-9 h-9 rounded-full border border-mg-main-blue bg-mg-main-blue-light flex items-center justify-center flex-shrink-0">
            <mg-icon iconName="info" iconClass="text-mg-main-blue-dark leading-none text-xl"></mg-icon>
          </div>
          <span class="text-mg-main-blue-dark font-medium text-sm">Debes regularizar esta marcación</span>
        </div>
        }
        @if (item.data.fin) {
        <div class="ml-5 w-px h-2.5"></div>
        <div @markEnter class="flex items-center justify-between border border-mg-main-blue rounded-xl px-2 py-3.5 min-h-[83px] bg-white transition-all duration-300"
          [class.!bg-mg-main-blue-light]="item.data.fin.isEnProceso"
          [class.!border-mg-main-blue]="item.data.fin.isEnProceso">
          <div class="flex items-center gap-3 min-w-0">
            <div class="w-9 h-9 rounded-full border bg-mg-main-blue-light border-mg-main-blue flex items-center justify-center flex-shrink-0"
              [class.!bg-mg-main-blue]="item.data.fin.isEnProceso"
              [class.!bg-mg-sunshine-light]="!item.data.fin.isEnProceso && item.data.fin.bEsPendiente"
              [class.!border-mg-sunshine-dark]="!item.data.fin.isEnProceso && item.data.fin.bEsPendiente"
              [class.!bg-mg-green-light]="!item.data.fin.isEnProceso && item.data.fin.bEsAprobada"
              [class.!border-mg-green-dark]="!item.data.fin.isEnProceso && item.data.fin.bEsAprobada"
              [matTooltip]="getDeviceTooltip(item.data.fin)"
              [matTooltipPosition]="(isScreenSM$ | async) ? 'left' : 'above'">
              <mg-icon [iconName]="item.data.fin.sIcono_Marcaje ?? 'computer'" iconClass="leading-none text-base"
                [class.text-white]="item.data.fin.isEnProceso"
                [class.text-mg-main-blue-dark]="!item.data.fin.isEnProceso && !item.data.fin.bEsPendiente && !item.data.fin.bEsAprobada"
                [class.text-mg-sunshine-dark]="!item.data.fin.isEnProceso && item.data.fin.bEsPendiente"
                [class.text-mg-green-dark]="!item.data.fin.isEnProceso && item.data.fin.bEsAprobada"
              ></mg-icon>
            </div>
            <div class="flex flex-col min-w-0">
              <div class="flex items-baseline gap-2 leading-none">
                <span class="text-xl font-bold text-mg-main-blue-dark leading-none">
                  {{ item.data.fin.dTiempo_Marca | date: 'HH:mm' }}
                </span>
                <span class="text-mg-main-blue-dark text-lg"> | </span>
                <span class="text-md text-mg-main-blue-dark">Fin</span>
              </div>
              <div class="flex items-center gap-1.5">
                <mg-icon iconName="today" iconClass="leading-none text-sm text-mg-main-blue-dark"></mg-icon>
                <span class="text-sm text-mg-main-blue-dark">
                  {{ item.data.fin.dTiempo_Marca | date: 'dd/MM/yyyy' }}
                </span>
              </div>
            </div>
          </div>
          <div class="flex items-center justify-end gap-1.5 flex-shrink-0 ml-2 sm:min-w-[120px]">
            @if (item.data.fin.isEnProceso) {
              <div class="flex flex-col items-end justify-between gap-1.5 self-stretch py-0.5">
                <span class="text-[10px] font-bold px-2 py-0.5 rounded-full leading-tight whitespace-nowrap"
                  [ngClass]="getActionCss(item.data.fin.displayActionType)">
                  {{ getActionLabel(item.data.fin.displayActionType) }}
                </span>
                <div class="flex items-center gap-1">
                  <span class="text-xs text-mg-main-blue-dark font-medium whitespace-nowrap">En Proceso</span>
                </div>
              </div>
            } @else {
              @if (item.data.fin.bEsPendiente) {
              <div
                class="hidden sm:flex items-center gap-1.5 text-sm text-mg-sunshine-dark border border-mg-sunshine-dark bg-mg-sunshine-light rounded-lg px-2.5 py-1">
                <mg-icon iconName="schedule" iconClass="text-mg-sunshine-dark leading-none text-sm"></mg-icon>
                <span>Pendiente</span>
              </div>
              } @else if (item.data.fin.bEsAprobada) {
                <div class="hidden sm:flex items-center gap-1.5 text-sm text-mg-green-dark border border-mg-green-dark bg-mg-green-light rounded-lg px-2.5 py-1">
                  <mg-icon iconName="check_circle" iconClass="text-green-600 leading-none text-sm"></mg-icon>
                  <span>Aprobada</span>
                </div>
              }
              @if (editMode && !lockButtons && !item.data.fin.bIs_Extemporanea) {
                @if ((showEditButtons && !item.data.fin.bEsPendiente) || showDelete(item.data.fin)) {
                  @if(!(isScreenSM$ | async)){
                    <button class="sm:hidden" mat-icon-button [matMenuTriggerFor]="menuFin">
                      <mg-icon iconName="more_vert" iconClass="text-mg-main-blue-dark leading-none text-base"></mg-icon>
                    </button>
                    <mat-menu #menuFin="matMenu">
                      @if(showEditButtons && !item.data.fin.bEsPendiente){
                        <button mat-menu-item
                          (click)="editarMarca.emit({ nInterval: item.data.fin.originalNInterval, nIndex: item.index + 1, nType_Mark: item.data.fin.originalNType_Mark, sHour: getHora(item.data.fin.dTiempo_Marca), sOriginalHour: getHora(item.data.fin.dTiempo_Marca) })">
                          <mg-icon matMenuItemIcon iconName="edit" iconClass="text-mg-main-blue-dark leading-none text-base"></mg-icon>
                          <div class="text-sm pl-1">Editar</div>
                        </button>
                      }
                      @if(showDelete(item.data.fin)){
                        <button mat-menu-item
                          (click)="editarMarca.emit({ nInterval: item.data.fin.originalNInterval, nIndex: item.index + 1, nType_Mark: item.data.fin.originalNType_Mark, sHour: '', sOriginalHour: getHora(item.data.fin.dTiempo_Marca) })">
                          <mg-icon matMenuItemIcon iconName="delete" iconClass="text-mg-red-dark leading-none text-base"></mg-icon>
                          <div class="text-sm pl-1">Eliminar</div>
                        </button>
                      }
                    </mat-menu>
                  } @else {
                    @if(showEditButtons && !item.data.fin.bEsPendiente){
                      <button
                        class="hidden sm:flex w-6 h-6 rounded-full bg-mg-main-blue-light items-center justify-center transition-colors"
                        (click)="editarMarca.emit({ nInterval: item.data.fin.originalNInterval, nIndex: item.index + 1, nType_Mark: item.data.fin.originalNType_Mark, sHour: getHora(item.data.fin.dTiempo_Marca), sOriginalHour: getHora(item.data.fin.dTiempo_Marca) })">
                        <mg-icon iconName="edit" iconClass="text-mg-main-blue-dark leading-none text-base"></mg-icon>
                      </button>
                    }
                    @if(showDelete(item.data.fin)){
                      <button
                        class="hidden sm:flex w-6 h-6 rounded-full bg-mg-red-light items-center justify-center transition-colors"
                        (click)="editarMarca.emit({ nInterval: item.data.fin.originalNInterval, nIndex: item.index + 1, nType_Mark: item.data.fin.originalNType_Mark, sHour: '', sOriginalHour: getHora(item.data.fin.dTiempo_Marca) })">
                        <mg-icon iconName="delete" iconClass="text-mg-red-dark leading-none text-base"></mg-icon>
                      </button>
                    }
                  }
                }
              }
            }
          </div>
        </div>
        @if (item.data.fin.isEnProceso && item.data.fin.displayActionType !== 'add') {
        <div @markEnter class="mt-1.5 flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-mg-main-blue-dark text-white text-[11px] font-semibold tracking-wide">
          <span>{{ getActionLabel(item.data.fin.displayActionType) }}</span>
          <span class="font-normal opacity-80">DE MARCA</span>
          <span>{{ item.data.fin.originalTime | date: 'HH:mm' }}</span>
          <span class="font-normal opacity-80">DEL DÍA</span>
          <span>{{ item.data.fin.originalTime | date: 'dd/MM/yyyy' }}</span>
        </div>
        }
        } @else if (item.data.inicio && canForceDelete(item.data.inicio)) {
        <div class="ml-5 w-px h-2.5"></div>
        <div class="flex items-center gap-3 border border-mg-main-blue rounded-xl px-2 py-3.5 bg-mg-main-blue-light min-h-[83px]">
          <div class="w-9 h-9 rounded-full border border-mg-main-blue bg-white flex items-center justify-center flex-shrink-0">
            <mg-icon iconName="info" iconClass="text-mg-main-blue-dark leading-none text-xl"></mg-icon>
          </div>
          <span class="text-mg-main-blue-dark font-medium text-sm">{{ fueraMessage(item.data.inicio) }}</span>
        </div>
        } @else if (item.data.inicio) {
        <div class="ml-5 w-px h-2.5"></div>
        <div class="flex items-center gap-3 border border-mg-main-blue rounded-xl px-2 py-3.5 bg-white min-h-[83px]">
          <div class="w-9 h-9 rounded-full border border-mg-main-blue bg-mg-main-blue-light flex items-center justify-center flex-shrink-0">
            <mg-icon iconName="info" iconClass="text-mg-main-blue-dark leading-none text-xl"></mg-icon>
          </div>
          <span class="text-mg-main-blue-dark font-medium text-sm">Debes regularizar esta marcación</span>
        </div>
        }
      </div>
      } @else if (item.type === 'permission') {
        <div
          class="flex items-center justify-center border rounded-xl px-3 py-2 mb-4 text-sm font-semibold bg-mg-main-blue-light border-mg-main-blue text-mg-main-blue-dark">
          {{ item.data.label | titlecase }} de {{ item.data.nMinutos }} min. de {{ item.data.dInicio | date: 'HH:mm' }} a {{ item.data.dFin | date: 'HH:mm' }}
        </div>
      } @else if (item.type === 'extension') {
        <div
          class="flex items-center justify-center border rounded-xl px-3 py-2 mb-4 text-sm font-semibold bg-mg-red-light border-mg-red-dark text-mg-red-dark">
          Extensión de Ausencias de {{ item.data.nMinutos }} min. de {{ item.data.dInicio | date: 'HH:mm' }} a {{ item.data.dFin | date: 'HH:mm' }}
        </div>
      }
    }
    @if (deletedMarks.length > 0) {
      <div @cardEnter class="mb-2 flex items-center gap-2">
        <mg-icon iconName="delete_forever" iconClass="text-base text-mg-red-dark"></mg-icon>
        <span class="text-sm font-semibold text-mg-red-dark tracking-wide">Marcas a eliminar</span>
      </div>
      @for (mark of deletedMarks; track mark.nId) {
      <div @markEnter class="flex items-center justify-between border border-mg-red-dark rounded-xl px-2 py-3.5 min-h-[83px] bg-[#FFE3E3] mb-2 transition-all duration-300">
        <div class="flex items-center gap-3 min-w-0">
          <div class="w-9 h-9 rounded-full bg-mg-red-dark flex items-center justify-center flex-shrink-0">
            <mg-icon [iconName]="mark.sIcono_Marcaje ?? 'computer'" iconClass="leading-none text-base text-white"></mg-icon>
          </div>
          <div class="flex flex-col min-w-0">
            <div class="flex items-baseline gap-2 leading-none">
              <span class="text-xl font-bold text-mg-main-blue-dark leading-none line-through">
                {{ mark.dTiempo_Marca | date: 'HH:mm' }}
              </span>
              <span class="text-mg-main-blue-dark text-lg"> | </span>
              <span class="text-md text-mg-main-blue-dark">{{ mark.originalNType_Mark === 1 ? 'Inicio' : 'Fin' }}</span>
            </div>
            <div class="flex items-center gap-1.5">
              <mg-icon iconName="today" iconClass="leading-none text-sm text-mg-main-blue-dark"></mg-icon>
              <span class="text-sm text-mg-main-blue-dark">{{ mark.dTiempo_Marca | date: 'dd/MM/yyyy' }}</span>
            </div>
          </div>
        </div>
        <div class="flex flex-col items-end justify-between gap-1.5 self-stretch py-0.5 ml-2">
          <span class="text-[10px] font-bold px-2 py-0.5 rounded-full leading-tight whitespace-nowrap bg-mg-red-dark text-white">ELIMINACIÓN</span>
          <div class="flex items-center gap-1">
            <span class="text-xs text-mg-main-blue-dark font-medium whitespace-nowrap">En Proceso</span>
          </div>
        </div>
      </div>
      }
    }
  }
</div>